import { render, staticRenderFns } from "./VerifiedStaff.vue?vue&type=template&id=2217c944"
import script from "./VerifiedStaff.vue?vue&type=script&lang=js"
export * from "./VerifiedStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports